// script.js (extrude index.html) ~sdg
'use strict'
console.time('LoadTime')
import './normalize.css'
import './style.css'
import * as THREE from 'three'
//import { LatheGeometry } from 'three/examples/src/geometries/CapsuleGeometry.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// Canvas
const canvas = document.querySelector('canvas.webgl')
// Scene
const scene = new THREE.Scene()
// Axes Helper
//const axesHelper = new THREE.AxesHelper(3)
//scene.add(axesHelper)
/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight
  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()
  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 4
camera.position.z = 4

scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.minDistance = 2
controls.maxDistance = 90

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({ canvas: canvas })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Objects
 */
const length = 2, width = 0.75
const shape = new THREE.Shape()
shape.moveTo(0, 0)
shape.lineTo(0, width)
shape.lineTo(length, width)
shape.lineTo(length, 0)
shape.lineTo(0, 0)

const x = 0, y = 0
const heartShape = new THREE.Shape()
heartShape.moveTo(x + 5, y + 5)
heartShape.bezierCurveTo(x + 5, y + 5, x + 4, y, x, y)
heartShape.bezierCurveTo(x - 6, y, x - 6, y + 7, x - 6, y + 7)
heartShape.bezierCurveTo(x - 6, y + 11, x - 3, y + 15.4, x + 5, y + 19)
heartShape.bezierCurveTo(x + 12, y + 15.4, x + 16, y + 11, x + 16, y + 7)
heartShape.bezierCurveTo(x + 16, y + 7, x + 16, y, x + 10, y)
heartShape.bezierCurveTo(x + 7, y, x + 5, y + 5, x + 5, y + 5)

const extrudeSettings = {
  steps: 1,
  depth: 1,
  bevelEnabled: true,
  bevelThickness: 0.2,
  bevelSize: 0.2,
  bevelOffset: 0,
  bevelSegments: 3
};

const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)
const material = new THREE.MeshNormalMaterial({ wireframe: false, flatShading: true })
const mesh = new THREE.Mesh(geometry, material);
mesh.position.x = -1.25
mesh.position.z = -0.5
mesh.rotation.x = Math.PI * 0.5
scene.add(mesh);

const wireframe = new THREE.WireframeGeometry(geometry)

const line = new THREE.LineSegments(wireframe)
line.material.depthTest = false
line.material.opacity = 0.5
line.material.transparent = false
line.material.color = new THREE.Color('slateblue')
line.position.x = -8
line.position.y = -3
line.position.z = -7
scene.add(line)

/**
 * Animate
 */
const clock = new THREE.Clock()
const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()
  // Update Controls
  controls.update()

  // Render
  renderer.render(scene, camera)
  window.requestAnimationFrame(animate)
}
animate()
console.timeEnd('LoadTime')
// EOF script.js (extrude index.html) ~sdg